import { render, staticRenderFns } from "./customers-modal.vue?vue&type=template&id=bc4d57b4&scoped=true&"
import script from "./customers-modal.vue?vue&type=script&lang=js&"
export * from "./customers-modal.vue?vue&type=script&lang=js&"
import style0 from "./customers-modal.vue?vue&type=style&index=0&id=bc4d57b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4d57b4",
  null
  
)

export default component.exports